import React, { useEffect, useRef, useState } from "react"
import "./MultiStepForm.css"
import ContactInfoForm from "./CompanyDetails"
import { updateCompany } from "../../apis/users"
import { useSelector } from "react-redux"
import StepIndicator from "./StepIndicator"
import Button from "../RequestsOverView/Button"
import AddLocation from "./AddLocation"
import addLocIcon from "../../assets/dspsignup/activeLocation.svg"
import ActiveCompany from "../../assets/dspsignup/companyDetailsActive.svg"
import activeLocation from "../../assets/dspsignup/activeLocation.svg"
import inactiveLocation from "../../assets/dspsignup/addLocInactive.svg"
import AddDroneInactive from "../../assets/dspsignup/AddDroneInactive.svg"
import activeDrone from "../../assets/dspsignup/activeDrone.svg"
import AddPilotInactive from "../../assets/dspsignup/AddPilotInactive.svg"
import activePilot from "../../assets/dspsignup/activePilot.svg"
import AddCropInactive from "../../assets/dspsignup/AddCropInactive.svg"
import activeCrop from "../../assets/dspsignup/activeCrop.svg"
import completedIcon from '../../assets/dspsignup/CompleteStep.svg'
import RightSideArrow from "../../assets/dspsignup/Arrow 2.svg"
import { addLocation } from "../../apis/locations"
import Popup from "../../ReusableFunctions/Popup"
import AddDrone from "./AddDrone."
import { checkOnboardingStatus, workDSPAsPilot } from "../../apis/operator"
import Loading from "../../ReusableFunctions/Loader"
import { addDSPDrone, addDSPDroneUAS, updateDSPDrone } from "../../apis/drones"
import AddDronePilotForm from "./AddDronePilotForm"
import { addDronePilot, updateDronePilot } from "../../apis/dronePilots"
import AddCropForm from "./AddCropForm"
import { saveCommonCropCost } from "../../apis/crops"
import { verifiedDSPAccount } from "../../apis/authentication"
import { useNavigate } from "react-router"
import  { useDispatch } from "react-redux"
import { setDsp } from "../../reducers/userReducer"
import { addService } from "../../apis/services"
import { v4 as uuidv4 } from "uuid";

const MultiStepForm = () => {
  const [currentStep, setCurrentStep] = useState(0)
  const [completedSteps, setCompletedSteps] = useState([])
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [setupStatus, setSetupStatus] = useState(null);
  const {user}=useSelector((state)=>state.user);
  const dispatch = useDispatch();
const navigate = useNavigate();
  const formRef = useRef();

  const updateDspDetails = async (data) => {
    if (!data) return; // Skip if no changes
    try {
      setIsSubmitting(true);
      await updateCompany(data);
      Popup.alert("Company Details", "Comapany Details added successfully", "SUCCESS", () => { });
    } catch (err) {
      Popup.alert("ERROR",err || "Something went wrong while updating company details","ERROR");
      throw err;
    }
  };

  const addDronesFunc=async(data)=>{
  try{
    setIsSubmitting(true);
    const addedModel=await addDSPDroneUAS(data);
     data={
      ...data,
      drone_uas_id: addedModel.id,
    }
    const drone=await addDSPDrone(data);
    Popup.alert("Drone", "Drone Added successfully", "SUCCESS", () => { });
    setIsSubmitting(false);
  }catch(err){
    Popup.alert("ERROR", err || "Something went wrong while adding drones. Please try again later", "ERROR", () => {  });
    throw err;
   }
  }

  const updateDronesFunc=async(data)=>{
    try{
     setIsSubmitting(true);
    const res=await updateDSPDrone(data);
    Popup.alert("Drone", "Drone updated successfully", "SUCCESS", () => { });
    setIsSubmitting(false);
    }catch(err){
      Popup.alert("ERROR", err||"Something went wrong while upadating drones. Please try again later", "ERROR", () => {  });
      throw err;
    }
  }

  const addLocationFunc = async (data) => {
    setIsSubmitting(true)
    try {
    const res=await addLocation(data, true);
   Popup.alert("Location", "Location added successfully", "SUCCESS", () => { });
    } catch (error) {
      Popup.alert("ERROR", error|| "Something went wrong while adding location", "ERROR", () => {  });
      throw error;
    }
  }

  const addDronePilotFunc = async (data) => {
   try{
    setIsSubmitting(true);
    await addDronePilot(data);
    Popup.alert("Drone pilot", "Drone pilot Added successfully", "SUCCESS", () => { });
    setIsSubmitting(false);
   }catch(err){
    Popup.alert("ERROR", err?.errorMessage ||"Something went wrong while adding drone pilot", "ERROR", () => {  });
    throw err;
   }
  }

  const updateDronePilotFunc = async (data) => {
    try{
      setIsSubmitting(true);
      await updateDronePilot(data);
      Popup.alert("Drone pilot", "Drone pilot updated successfully", "SUCCESS", () => { });
      setIsSubmitting(false);
     }catch(err){
      Popup.alert("ERROR", err?.errorMessage || "Something went wrong while upadating drone pilot", "ERROR", () => {  });
      throw err;
     }
  }

  const workAsPilotFunc=async(data)=>{
    try{
     setIsSubmitting(true);
     const res=await workDSPAsPilot(data);
     Popup.alert("Drone pilot", "Drone pilot updated successfully", "SUCCESS", () => { });
    }catch(err){
      Popup.alert("ERROR", err?.errorMessage || "Something went wrong while upadating drone pilot", "ERROR", () => {  });
      throw err;
    }
  }

  const AddCropFunc = async (crops) => {
    setIsSubmitting(true)
    try {
      const data=await saveCommonCropCost(crops);
      const res=await verifiedDSPAccount();
      Popup.alert("Profile Complete", "profile setup done successfully !", "SUCCESS", () => {
        dispatch(setDsp({ is_verified: true }));
      navigate("/");
       });
     setIsSubmitting(false);
    } finally {
      setIsSubmitting(false)
    }
  }


  const steps = [
    {
      id: 0,
      title: "Set up your Company Details",
      description: "Add your company details to setup your account",
      component: ContactInfoForm,
      apiCall: updateDspDetails,
      activeIcon:ActiveCompany,
      inActiveIcon:addLocIcon,
      completedIcon:completedIcon,
    },
    {
      id: 1,
      title: "Set up your service location",
      description: "Set up your service location to start your business . you can add more locations.",
      component: AddLocation,
      apiCall: addLocationFunc,
      activeIcon:activeLocation,
      inActiveIcon:inactiveLocation,
      completedIcon:completedIcon,
    },
    {
      id: 2,
      title: "Add your drone",
      description: "Add your drone to start your business. You can add more drones.",
      component: AddDrone,
      apiCall: (data, isEditing) => isEditing ? updateDronesFunc(data) : addDronesFunc(data),
      activeIcon:activeDrone,
      inActiveIcon:AddDroneInactive,
      completedIcon:completedIcon,
    },
    {
      id: 3,
      title: "Add pilot",
      description: "Add pilot and assign drone and then you are ready to start your business",
      component: AddDronePilotForm,
      apiCall: async (data, isEditing) => {
        console.log("data",data);
        if (data.isDspWorkAsPilot) {
          if (!data.isCompleted) {
            // First time calling workAsPilot API
            return await workAsPilotFunc({
              assigned_drone: data.assigned_drone,
              drone_id: data.drone_id
            });
          }
          // If already completed, no API call needed
          return true;
        } else {
          // Original logic for adding/updating pilot
          return isEditing 
            ? await updateDronePilotFunc(data) 
            : await addDronePilotFunc(data);
        }
      },
      activeIcon: activePilot,
      inActiveIcon: AddPilotInactive,
      completedIcon: completedIcon,
    },
    {
        id: 4,
        title: "Add crop",
        description: "Add atleast one crop to start your business.",
        component: AddCropForm,
        apiCall: AddCropFunc,
        activeIcon:activeCrop,
        inActiveIcon:AddCropInactive,   
        completedIcon:completedIcon,
      }
  ]

  // API functions


  const handleNext = async (stepData, isEditing = false) => {      
    const currentStepConfig = steps[currentStep];
  
    try {
      setIsSubmitting(true);
      Loading.set(true);
  
      // Special check for "Add crop" step (id: 4)
      if (currentStepConfig.id === 4) {
        if (stepData && stepData.length > 0 && currentStepConfig.apiCall) {
          await currentStepConfig.apiCall(stepData, isEditing);
          
          if (!completedSteps.includes(currentStep)) {
            setCompletedSteps(prev => [...prev, currentStep]);
          }
          if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
          }
        } else {
          console.log("No crops added; staying on this step.");
        }
      } 
      else {
        // Previous steps: same logic as before
        if (stepData && currentStepConfig.apiCall) {
          await currentStepConfig.apiCall(stepData, isEditing);
        } else {
          console.log("No changes, skipping API call");
        }
  
        if (!completedSteps.includes(currentStep)) {
          setCompletedSteps(prev => [...prev, currentStep]);
        }
  
        if (currentStep < steps.length - 1) {
          setCurrentStep(currentStep + 1);
        }
      }
  
    } catch (error) {
      console.error('API call failed:', error);
      // Don't proceed if API call failed
      return; 
    } finally {
      setIsSubmitting(false);
      Loading.set(false);
    }
  };
  


  const getonboardingSteps=async()=>{
    Loading.set(true);
    try{
      let onbordingDetails =await checkOnboardingStatus();
      setSetupStatus(()=>onbordingDetails);
      const completed = [];
      if (onbordingDetails.isCompanyDetailsComplete) completed.push(0);
      if (onbordingDetails.isLocationExist) completed.push(1);
      if (onbordingDetails.isDroneExist) completed.push(2);
      if (onbordingDetails.isPilotExist) completed.push(3);
      if (onbordingDetails.isCropExist) completed.push(4);
      
      setCompletedSteps(completed);
      
      // Find first incomplete step
      const firstIncomplete = steps.findIndex(
        (_, index) => !completed.includes(index)
      );
      
      // Redirect to first incomplete step or stay at 0 if all complete
      setCurrentStep(firstIncomplete !== -1 ? firstIncomplete : 0);
      Loading.set(false);
    }catch(err){
      Loading.set(false);
      console.error("Error fetching setup status:", err);
      setCurrentStep(0);
    }
  }

  useEffect(()=>{
    if(user.dsp?.is_verified){
      navigate('/');
    }
   getonboardingSteps();
  },[])

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1)
    }
  }

  const CurrentStepComponent = steps[currentStep].component

  return (
    <div style={{
        width:"100%",
        padding:"10px 20px",
        display:"flex",
        height:"100%",
    }}>

         <div style={{width:"35%",height:"auto"}}>
           <StepIndicator
            steps={steps} 
            currentStep={currentStep} 
            completedSteps={completedSteps} 
           />
         </div>
         <div style={{width:"65%",height :"100%", padding:"20px 25px" ,}}>
        <div style={{
          height:"90%",
          minHeight:"90%",
          padding:"10px 60px",
        }}>
          <CurrentStepComponent 
                 onNext={handleNext}
                 ref={formRef}
                />
        </div>
        <div style={{
  width: "100%",
  padding: "10px 60px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between"
}}>
  {currentStep !== 0 ? (
    <Button
      variant={"outlined"}
      title={"Back"}
      width={"100px"}
      isDisbaled={isSubmitting}
      handleClick={handleBack}
      color={"#848484"}
      hoverColor={"#848484"}
      isRightIcon={false}
      iconStyle={{ width: 16, height: 16 }}
    />
  ) : (
    <div style={{ width: "100px" }} /> // empty div to keep space
  )}

  <Button
    variant={"filled"}
    title={"Next"}
    isDisbaled={isSubmitting}
    width={"100px"}
    handleClick={() => { formRef.current?.submitForm() }}
    color={"#0F5EFF"}
    icon={RightSideArrow}
    hoverColor={"#1251D2"}
    isRightIcon={true}
    iconStyle={{ width: 16, height: 16, marginTop: 0 }}
    style={{display: "flex", justifyContent: "center"}}
  />
</div>
         </div>
        </div>
    
  )
}

export default MultiStepForm